import { API, graphqlOperation } from 'aws-amplify';
import { createActivity } from '@/graphql/mutations';

export const useActivity = () => {
	const createActivityMutation = async (payload) => {
		await API.graphql(graphqlOperation(createActivity, {
			input: payload,
		}));
	};

	return {
		createActivityMutation,
	};
};

export default useActivity;
